import { chemicalsDataListSelector } from '@/redux/chemicals/chemicals.selectors';
import { store } from '@/redux/store';
import type { Chemical } from 'minerva-plugin-api';
import { toPluginChemical } from '@/services/pluginsManager/adapters/toPluginModelElement';

export const getAllChemicals = (): Chemical[] => {
  const { getState } = store;
  const chemicals = chemicalsDataListSelector(getState());

  return (chemicals || []).map(toPluginChemical);
};
